<template>
    <div>
        <q-table
            :data="audios"
            :columns="columns"
            :pagination.sync="server_pagination"
            @request="request"
            :loading="loading"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            binary-state-sort
            class="q-mt-md"
            >

            <template slot="top" slot-scope="props">
                <div class="col" />
                <q-btn color="secondary" icon="far fa-plus" :label="$t('new')" @click="showAudio(0)" :disable="!managePodcasts"/>
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props" :props="props">
                <q-td auto-width key="id" :props="props">
                    {{ props.row.id }}
                </q-td>

                <q-td key="title" :props="props">
                    {{ props.row.title }}
                </q-td>

                <q-td key="duration" :props="props">
                    {{ props.row.duration }}
                </q-td>

                <q-td auto-width key="status" :props="props">
                    <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                        {{ $t(getStatus(props.row.status)) }}
                    </q-chip>
                </q-td>

                <q-td key="actions" :props="props">
                    <q-btn flat round color="primary" icon="far fa-pencil-alt" @click="showAudio(props.row.actions)" :disable="!managePodcasts" >
                        <q-tooltip>
                            {{ $t('view_or_edit_tooltip') }}
                        </q-tooltip>
                    </q-btn>

                    <q-btn flat round color="negative" icon="far fa-trash-alt" @click="confirmRemove(props.row.actions)" :disable="!managePodcasts" >
                        <q-tooltip>
                            {{ $t('delete_tooltip') }}
                        </q-tooltip>
                    </q-btn>
                </q-td>
            </q-tr>
        </q-table>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'admin_podcasts' })" />
            </div>
        </div>

        <q-modal v-model="show_audio" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" no-backdrop-dismiss no-esc-dismiss>
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="hideAudio()" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('audio') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <div class="row gutter-sm">
                        <div class="col-12">
                            <q-input v-model="title" :float-label="$t('title')" :error="$v.title.$error" @input="$v.title.$touch" />
                        </div>

                        <div class="col-12">
                            <div class="row gutter-sm">
                                <div class="col-xs-12 col-sm-6">
                                    <p class="caption">{{ $t('audio') }}</p>
                                    <uploader content_type="audio" @fileUploaded="fileUploaded" :multiple="false" :cropper="false" :error="$v.file_url.$error" @input="$v.file_url.$touch" />

                                    <p v-if="file_url" class="q-mt-md file-url">
                                        <q-icon name="fal fa-check" color="positive" />
                                        <a :href="file_url" target="_blank"> {{ $truncateLink(file_url) }}</a>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row gutter-sm justify-end q-mt-lg">
                        <div class="col-xs-12 col-sm-3" :class="getOrder('cancel')">
                            <q-btn color="tertiary" class="full-width" :label="$t('cancel')" icon="far fa-ban" @click="hideAudio()" />
                        </div>

                        <div class="col-xs-12 col-sm-3" :class="getOrder('save')">
                            <q-btn color="secondary" class="full-width" :label="$t('save')" icon="far fa-save" @click="saveAudio()" />
                        </div>
                    </div>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="confirm_remove" @ok="removeAudio()">
            <span slot="title">{{ $t('remove_item') }}</span>

            <span slot="message">{{ $t('confirm_remove_item') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeAudio()" />
            </template>
        </q-dialog>

        <audio :src="file_url" id="audio" style="display: hidden;"></audio>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { required, requiredIf, maxValue, minValue } from 'vuelidate/lib/validators'
import Uploader from 'components/Uploader'

export default {
    props: [ 'managePodcasts' ],

    data() {
        return {
            id: '',
            id_audio: '',
            server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            audios: [],
            columns: [
                {
                    name: 'id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'id',
                    sortable: true,
                },
                {
                    name: 'title',
                    required: true,
                    label: 'audio',
                    align: 'left',
                    field: 'title',
                    sortable: true,
                },
                {
                    name: 'duration',
                    required: true,
                    label: 'duration',
                    align: 'left',
                    field: 'duration',
                    sortable: true,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: true,
                },
                {
                    name: 'actions',
                    required: true,
                    label: '',
                    align: 'right',
                    field: 'edit',
                    sortable: false,
                },
            ],
            loading: false,
            show_audio: false,
            confirm_remove: false,
            title: '',
            file_url: '',
            audio: null,
            duration: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token',
            test_types: 'registration_lists/group_training_test_types'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '80vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        }
    },

    components: {
        'uploader': Uploader,
    },

    methods: {
        request ({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": this.filter,
                "ordering": order_by
            }

            this.$axios.get(`/admin_podcast/podcasts/${this.id}/audios/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.audios = response.data.results.map(e => {
                    return {
                        ...e,
                        actions: e.id
                    }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        confirmRemove(id) {
            this.id_audio = id
            this.confirm_remove = true
        },

        removeAudio() {
            this.$q.loading.show()

            this.$axios.delete(`/admin_podcast/podcasts/${this.id}/audios/${this.id_audio}/`, this.getHeader)
            .then(response => {
                this.request({
                    pagination: this.server_pagination
                })

                this.confirm_remove = false

                this.$q.notify({
                    message: this.$t('item_removed_success'),
                    type: 'positive',
                    icon: 'far fa-trash-alt'
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        showAudio(id) {
            this.id_audio = id

            if (this.id_audio !== 0) {
                this.$q.loading.show()

                this.$axios.get(`/admin_podcast/podcasts/${this.id}/audios/${this.id_audio}/`, this.getHeader)
                .then(response => {
                    this.title = response.data.title
                    this.file_url = response.data.resource_url
                })
                .catch(e => {
                    console.log(e)
                })
                .finally(() => {
                    this.$q.loading.hide()
                    this.show_audio = true
                })
            }
            else {
                this.show_audio = true
            }
        },

        fileUploaded(url) {
            let data = {
                file_url: url
            }

            this.$axios.post('/utils/presigned_url/', data, this.getHeader)
            .then(response => {
                this.file_url = response.data.file_url
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        saveAudio() {
            this.$v.$touch()

            if (!this.$v.$error) {
                this.$q.loading.show()

                let data = {
                    title: this.title,
                    resource: this.file_url,
                    duration: this.duration
                }

                if (this.id_audio != 0) {
                    this.$axios.put(`/admin_podcast/podcasts/${this.id}/audios/${this.id_audio}/`, data, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('audio_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('audio_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                        this.hideAudio()
                    })
                }
                else {
                    this.$axios.post(`/admin_podcast/podcasts/${this.id}/audios/`, data, this.getHeader)
                    .then(response => {
                        this.$q.notify({
                            message: this.$t('audio_save_success'),
                            type: 'positive',
                            icon: 'fal fa-save'
                        })
                    })
                    .catch(e => {
                        console.log(e)

                        this.$q.notify({
                            message: this.$t('audio_save_error'),
                            type: 'negative',
                            icon: 'fal fa-ban'
                        })
                    })
                    .finally(() => {
                        this.$q.loading.hide()
                        this.hideAudio()
                    })
                }
            }
            else{
                this.$q.notify({
                    message: this.$t('make_sure_that_all_fields_are_filled_in'),
                    type: 'negative',
                    icon: 'fal fa-exclamation-triangle',
                    position: 'top'
                })
            }
        },

        hideAudio() {
            this.request({
                pagination: this.server_pagination
            })

            this.id_audio = ''
            this.title = ''
            this.file_url = ''
            this.show_audio = false

            this.$v.$reset()
        },

        getStatus(status) {
            if (status == 1) return 'published'
            else if (status == 2) return 'unpublished'
            else if (status == 3) return 'deleted'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        },

        loadedAudio() {
            if (this.audio.readyState >= 2) {
                let duration_seconds = parseInt(this.audio.duration)
                this.duration = new Date(duration_seconds * 1000).toISOString().substr(11, 8)
			}
        }
    },

    validations() {
        return {
            title: { required },
            file_url: { required },
        }
    },

    created() {
        this.id = this.$route.params.id

        this.request({
            pagination: this.server_pagination
        })
    },

    mounted() {
        this.audio = this.$el.querySelectorAll('audio')[0]
        this.audio.addEventListener('loadeddata', this.loadedAudio)
    }
}
</script>

<style>

</style>
